import { Link } from "@tanstack/react-router";
import type { Tag } from "@/typings/wp";
import { LinkBuilder } from "@/services/link-builder";
import cls from "./styles.module.css";
import cn from "clsx";

type TProps = {
  className?: string;
  tags: Pick<Tag, "name" | "id" | "slug">[];
};
const TagsList = (props: TProps) => {
  return (
    <ul className={cn(cls.root, props.className)}>
      {props.tags.map(({ name, slug, id }) => (
        <li key={id}>
          <Link
            to={LinkBuilder.build({
              route: "posts-by-tag",
              tag: slug!,
            })}
          >
            #{name}
          </Link>
        </li>
      ))}
    </ul>
  );
};
export default TagsList;
